"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _type = require("./type.js");

var _layout = require("./layout.js");

var _classnames = _interopRequireDefault(require("classnames"));

var _CFontIcon = _interopRequireDefault(require("./CFontIcon.js"));

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  &.draft,\n  &.archived {\n    background-color: ", ";\n  }\n\n  &.live,\n  &.active {\n    background-color: ", ";\n  }\n\n  &.pending {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TYPES = {
  LIVE: "live",
  DRAFT: "draft",
  ACTIVE: "active",
  PENDING: "pending",
  ARCHIVED: "archived"
};

var CLabel = function CLabel(_ref) {
  var type = _ref.type,
      children = _ref.children,
      boxProps = (0, _chunkB2edacfb.j)(_ref, ["type", "children"]);
  return !type ? null : _react.default.createElement(StyledLabel, (0, _chunkB2edacfb.g)({}, boxProps, {
    className: (0, _classnames.default)("clabel", type)
  }), _react.default.createElement(_type.H5, {
    light: true,
    type: type === TYPES.archived ? "secondary" : "primary"
  }, children || type));
};

CLabel.propTypes = (0, _chunkB2edacfb.i)({}, _layout.Box.propTypes, {
  type: _propTypes.default.string.isRequired
});
CLabel.defaultProps = (0, _chunkB2edacfb.i)({}, _layout.Box.defaultProps, {
  display: "flex",
  height: "24px",
  borderRadius: 6,
  paddingX: 8,
  cursor: "default",
  userSelect: "none"
});
CLabel.enums = {
  TYPES: TYPES
};
var StyledLabel = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "CLabel__StyledLabel",
  componentId: "sc-1xdm5hz-0"
})(_templateObject(), function (props) {
  return props.theme["$gray-5"];
}, function (props) {
  return props.theme["$green"];
}, function (props) {
  return props.theme["$yellow"];
});
CLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CLabel",
  "props": {
    "display": {
      "defaultValue": {
        "value": "\"flex\"",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "\"24px\"",
        "computed": false
      },
      "required": false
    },
    "borderRadius": {
      "defaultValue": {
        "value": "6",
        "computed": false
      },
      "required": false
    },
    "paddingX": {
      "defaultValue": {
        "value": "8",
        "computed": false
      },
      "required": false
    },
    "cursor": {
      "defaultValue": {
        "value": "\"default\"",
        "computed": false
      },
      "required": false
    },
    "userSelect": {
      "defaultValue": {
        "value": "\"none\"",
        "computed": false
      },
      "required": false
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  },
  "composes": ["../../layout/layout"]
};
var _default = CLabel;
exports.default = _default;
CLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CLabel",
  "composes": ["./chunk-b2edacfb.js"]
};